import { render, staticRenderFns } from "./GuidanceDiagram.vue?vue&type=template&id=5c2bcaf2&scoped=true"
import script from "./GuidanceDiagram.vue?vue&type=script&lang=js"
export * from "./GuidanceDiagram.vue?vue&type=script&lang=js"
import style0 from "./GuidanceDiagram.vue?vue&type=style&index=0&id=5c2bcaf2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2bcaf2",
  null
  
)

export default component.exports